var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { html } from 'lit';
import '../_sds-button-base.lit';
import styles from './sds-split-button.lit.scss';
import { SdsButtonDropdownBase } from '../_sds-button-dropdown-base.lit';
import { sdsCustomElement } from '../../utilities/custom-components';
let SdsButtonSplit = (() => {
    let _classDecorators = [sdsCustomElement('sds-button-split')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsButtonDropdownBase;
    var SdsButtonSplit = _classThis = class extends _classSuper {
        render() {
            return html ` ${this.renderButtonSplit()} `;
        }
        renderButtonSplit() {
            return html `
            <div
                class="sds-button-split ${this.type === 'elevated'
                ? 'sds-button-split--elevated'
                : ''} ${this.opened ? 'sds-button-split--dropdown-selected' : ''}"
            >
                ${this.renderButtonSplitDefault()} ${this.renderButtonSplitDropdown()}
            </div>
        `;
        }
        renderButtonSplitDefault() {
            return html `
            <button
                class="sds-button--default ${this.getClasses()}"
                .disabled="${this.disabled}"
                @click="${(e) => this.handleClick(e)}"
                part="sds-button"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
                aria-label="${this.label ? this.label : this.iconName}"
            >
                ${this.icon ? this.renderIcon() : ''} ${this.label}
            </button>
        `;
        }
        handleClick(e) {
            this.dispatchAction();
            this.closeContextMenu();
            e.stopPropagation();
        }
        dispatchAction() {
            this.dispatchEvent(new CustomEvent(SdsButtonSplit.BUTTON_CLICKED));
        }
        renderIcon() {
            return html `
            <sds-icon size="${this._iconSize}" name="${this.icon}" aria-hidden="true"></sds-icon>
        `;
        }
        renderButtonSplitDropdown() {
            return html `
            <button
                id="trigger"
                class="sds-button--dropdown ${this.getClasses()}"
                .disabled="${this.disabled}"
                @click="${() => this.toggleContextMenu()}"
                @keydown="${this.handleKeyDown}"
                part="sds-button"
                aria-haspopup="menu"
                aria-expanded="${this.opened}"
                aria-label="Toggle dropdown menu"
                aria-disabled="${this.disabled ? 'true' : 'false'}"
            >
                <sds-icon
                    size="${this._iconSize}"
                    name="${this.opened ? 'arrow_up_small' : 'arrow_down_small'}"
                ></sds-icon>
            </button>

            <div id="dropdown-status" class="sr-only" aria-live="polite"></div>

            <sds-context-menu
                position="below"
                ?hidden="${!this.opened}"
                @menu-closed="${this.handleMenuClosed}"
            >
                <slot></slot>
            </sds-context-menu>
        `;
        }
        // Override to handle class removal when menu opens
        updated(changedProperties) {
            var _a;
            super.updated(changedProperties);
            if (changedProperties.has('opened')) {
                const defaultButton = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-button--default');
                if (defaultButton) {
                    if (this.opened) {
                        defaultButton.classList.remove('sds-button--selected');
                    }
                }
            }
        }
    };
    __setFunctionName(_classThis, "SdsButtonSplit");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsButtonSplit = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.BUTTON_CLICKED = 'sds.button.clicked';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsButtonSplit = _classThis;
})();
export { SdsButtonSplit };
